import { useTimeout } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-timeout
 */
export default useTimeout;
